(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5613],{

/***/ 30621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ o; }
});

// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
;// CONCATENATED MODULE: ../../node_modules/@hookform/resolvers/dist/resolvers.module.js
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,index_esm/* get */.U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},resolvers_module_t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&resolvers_module_t(e,f);var o={};for(var a in e){var n=(0,index_esm/* get */.U2)(f.fields,a);(0,index_esm/* set */.t8)(o,a,Object.assign(e[a],{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map

;// CONCATENATED MODULE: ../../node_modules/@hookform/resolvers/yup/dist/yup.module.js
var o=function(o,n,a){return void 0===n&&(n={}),void 0===a&&(a={}),function(s,i,c){try{return Promise.resolve(function(t,r){try{var u=(n.context&&"development"==="production"&&0,Promise.resolve(o["sync"===a.mode?"validateSync":"validate"](s,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t){return c.shouldUseNativeValidation&&resolvers_module_t({},c),{values:a.rawValues?s:t,errors:{}}}))}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return{values:{},errors:f((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,a=o&&o[t.type];e[t.path]=(0,index_esm/* appendErrors */.KN)(t.path,n,e,t.type,a?[].concat(a,t.message):t.message)}return e},{})),c)};var o,n}))}catch(e){return Promise.reject(e)}}};
//# sourceMappingURL=yup.module.js.map


/***/ }),

/***/ 90359:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/signup",
      function () {
        return __webpack_require__(42285);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SkipperTextLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61278);




function SkipperTextLogo(param) {
    var _href = param.href, href = _href === void 0 ? "/auth/signin" : _href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center cursor-pointer",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_elements_SkipperLogo__WEBPACK_IMPORTED_MODULE_3__/* .SkipperLogo */ .j, {
                    className: "w-12 h-12 fill-current text-teal-600 mr-2 transform scale-110"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-4xl text-passport font-bold font-inter",
                    children: "Skipper"
                })
            ]
        })
    });
}


/***/ }),

/***/ 93997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Wave; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



function Wave(param) {
    var className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute top-32 bottom-0 right-0 left-0 z-0", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 1440 640",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none",
        className: classNames,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M473 15.9267C217.959 37.5808 116 31.8926 0 20.7249V640H1440V7.72198C1363 20.7249 915 -21.6011 473 15.9267Z",
            fill: "#e8f6f8",
            fillOpacity: "1"
        })
    });
}


/***/ }),

/***/ 42285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Signup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78616);
/* harmony import */ var _components_base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34867);
/* harmony import */ var _components_common_svgs_WaveSVG__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93997);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65413);
/* harmony import */ var _graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52789);
/* harmony import */ var _components_common_svgs_EyeconSVG__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78627);
/* harmony import */ var _components_common_svgs_EyeconClosedSVG__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87310);
/* harmony import */ var _components_common_header_SkipperTextLogo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98451);
/* harmony import */ var _components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47614);
/* harmony import */ var _skipper_ui__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23357);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63955);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30621);
















var FormValidationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    firstName: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("First name is required"),
    lastName: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Last name is required"),
    email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Email is required"),
    password: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Password is required")
});
function Signup() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showSignUpForm = ref[0], setShowSignUpForm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), userId = ref2[0], setUserId = ref2[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "h-screen overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .TitleAndTags */ .x5, {
                title: "Signup"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "pt-10 px-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center justify-between px-20",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_header_SkipperTextLogo__WEBPACK_IMPORTED_MODULE_9__/* .SkipperTextLogo */ .C, {
                        href: "https://skipper.io"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative pt-10 h-full ",
                children: [
                    showSignUpForm && !email && !userId ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SignupForm, {
                        setShowSignUpForm: setShowSignUpForm,
                        setEmail: setEmail,
                        setUserId: setUserId
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VerifyEmail, {
                        email: email,
                        userId: userId,
                        setShowSignUpForm: setShowSignUpForm,
                        setEmail: setEmail,
                        setUserId: setUserId
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_svgs_WaveSVG__WEBPACK_IMPORTED_MODULE_4__/* .Wave */ .i, {})
                ]
            })
        ]
    });
};
var SignupForm = function(param) {
    var setShowSignUpForm = param.setShowSignUpForm, setEmail = param.setEmail, setUserId = param.setUserId;
    var dispatchNotification = (0,_components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_10__/* .useUniversalModalDispatch */ .Xt)().dispatchNotification;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
        defaultValues: {
            firstName: "",
            lastName: "",
            email: "",
            password: ""
        }
    }), register = ref.register, handleSubmit = ref.handleSubmit, control = ref.control;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showPassword = ref1[0], setShowPassword = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), checkboxState = ref2[0], setCheckboxState = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), emailErrorsArray = ref3[0], setEmailErrorsArray = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), passwordErrorsArray = ref4[0], setPasswordErrorsArray = ref4[1];
    var initialValues = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            firstName: "",
            lastName: "",
            email: "",
            password: ""
        };
    }, []);
    var createAccountMutation = (0,_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .useCreateAccountMutation */ .xKW)((0,_graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_6__/* .getClient */ .s3)("users"), {
        onSuccess: function(data) {
            var ref;
            if (data === null || data === void 0 ? void 0 : (ref = data.createAccount) === null || ref === void 0 ? void 0 : ref.success) {
                var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                dispatchNotification({
                    title: "Account created successfully",
                    text: "",
                    type: "success"
                });
                var ref9;
                setEmail((ref9 = data === null || data === void 0 ? void 0 : (ref1 = data.createAccount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.account) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.users) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.email) !== null && ref9 !== void 0 ? ref9 : "");
                var ref10;
                setUserId((ref10 = data === null || data === void 0 ? void 0 : (ref5 = data.createAccount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.account) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.users) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.id) !== null && ref10 !== void 0 ? ref10 : "");
                setShowSignUpForm(false);
            // router.back();
            } else {
                var ref11, ref12, ref13, ref14;
                if (!!(data === null || data === void 0 ? void 0 : (ref11 = data.createAccount) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.errors) === null || ref12 === void 0 ? void 0 : ref12.length)) {
                    var ref15, ref16, ref17, ref18;
                    setEmailErrorsArray(data === null || data === void 0 ? void 0 : (ref15 = data.createAccount) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.errors) === null || ref16 === void 0 ? void 0 : ref16.filter(function(e) {
                        return e.toLocaleLowerCase().includes("email");
                    }));
                    setPasswordErrorsArray(data === null || data === void 0 ? void 0 : (ref17 = data.createAccount) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.errors) === null || ref18 === void 0 ? void 0 : ref18.filter(function(e) {
                        return e.toLocaleLowerCase().includes("password");
                    }));
                }
                var ref19;
                dispatchNotification({
                    title: "Error creating account",
                    text: (ref19 = data === null || data === void 0 ? void 0 : (ref13 = data.createAccount) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.errors) === null || ref14 === void 0 ? void 0 : ref14[0]) !== null && ref19 !== void 0 ? ref19 : "Something went wrong. Please try again later.",
                    type: "danger"
                });
            }
        }
    });
    var successCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(vals) {
        createAccountMutation.mutate({
            firstName: vals.firstName,
            lastName: vals.lastName,
            email: vals.email,
            password: vals.password
        });
    }, [
        createAccountMutation
    ]);
    var errorCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(errors) {
        if (errors) {
            dispatchNotification({
                title: "Error",
                text: "Please fill out the required fields",
                type: "danger"
            });
        }
    }, []);
    var methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)({
        defaultValues: initialValues,
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_13__/* .yupResolver */ .X)(FormValidationSchema),
        mode: "all"
    });
    var errors = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useFormState */ .cl)({
        control: control
    }).errors;
    var container = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var Eyecon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "absolute right-0 top-0 bottom-0 flex items-center pr-4 cursor-pointer",
        onClick: function() {
            return setShowPassword(function(s) {
                return !s;
            });
        },
        children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_svgs_EyeconSVG__WEBPACK_IMPORTED_MODULE_7__/* .EyeconSVG */ .C, {
            className: "fill-current text-gray-800"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_svgs_EyeconClosedSVG__WEBPACK_IMPORTED_MODULE_8__/* .EyeconClosedSVG */ ._, {
            className: "absolute right-0 top-0 bottom-0"
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "z-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-10 lg:px-20 py-12 bg-white rounded-sm z-10 shadow-md border border-gray-100 lg:w-[50%] min-w-[400px] max-w-[700px]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:px-10 md:text-4xl text-xl text-passport font-inter font-bold mb-4 text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: "Sign-up for a"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "md:mt-5",
                                        children: "Skipper account"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .FormProvider */ .RV, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, methods), {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-6 flex flex-col items-start gap-y-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .LabelForInput */ .WO, {
                                                        htmlFor: "firstName",
                                                        children: "First name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                        id: "firstName",
                                                        name: "firstName",
                                                        showErrorOutline: !!(errors === null || errors === void 0 ? void 0 : errors.firstName)
                                                    }, register("firstName", {
                                                        required: true
                                                    }))),
                                                    !!(errors === null || errors === void 0 ? void 0 : errors.firstName) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-red-500 mt-1 text-xs",
                                                        children: "This field is required"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .LabelForInput */ .WO, {
                                                        htmlFor: "lastName",
                                                        className: "mt-2",
                                                        children: "Last name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                        id: "lastName",
                                                        name: "lastName",
                                                        showErrorOutline: !!(errors === null || errors === void 0 ? void 0 : errors.lastName)
                                                    }, register("lastName", {
                                                        required: true
                                                    }))),
                                                    (errors === null || errors === void 0 ? void 0 : errors.lastName) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-red-500 mt-1 text-xs",
                                                        children: "This field is required"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .LabelForInput */ .WO, {
                                                        htmlFor: "email",
                                                        className: "mt-2",
                                                        children: "Email"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                        id: "email",
                                                        name: "email",
                                                        showErrorOutline: !!(errors === null || errors === void 0 ? void 0 : errors.email) || !!emailErrorsArray.length
                                                    }, register("email", {
                                                        required: true
                                                    }))),
                                                    (errors === null || errors === void 0 ? void 0 : errors.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-red-500 mt-1 text-xs",
                                                        children: "This field is required"
                                                    }),
                                                    !!emailErrorsArray.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: emailErrorsArray === null || emailErrorsArray === void 0 ? void 0 : emailErrorsArray.map(function(e, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-red-500 mt-1 text-xs",
                                                                children: e
                                                            }, "email_error_".concat(index));
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .LabelForInput */ .WO, {
                                                        htmlFor: "password",
                                                        className: "mt-2",
                                                        children: "Password"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "relative w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                                                                type: "".concat(showPassword ? "text" : "password"),
                                                                id: "password",
                                                                name: "password",
                                                                showErrorOutline: !!(errors === null || errors === void 0 ? void 0 : errors.password) || !!passwordErrorsArray.length
                                                            }, register("password", {
                                                                required: true
                                                            }))),
                                                            Eyecon
                                                        ]
                                                    }),
                                                    (errors === null || errors === void 0 ? void 0 : errors.password) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-red-500 mt-1 text-xs",
                                                        children: "This field is required"
                                                    }),
                                                    !!passwordErrorsArray.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: passwordErrorsArray === null || passwordErrorsArray === void 0 ? void 0 : passwordErrorsArray.map(function(e, index) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-red-500 mt-1 text-xs",
                                                                children: e
                                                            }, "email_error_".concat(index));
                                                        })
                                                    }),
                                                    !passwordErrorsArray.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-xs text-gray-500 mt-1",
                                                        children: "8 characters, including upper and lowercase letters and a digit"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center mt-8",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_3__/* .Checkbox */ .XZ, {
                                                setChecked: function() {
                                                    return setCheckboxState(function(s) {
                                                        return !s;
                                                    });
                                                },
                                                checked: checkboxState,
                                                name: "TermsAndPolicy"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "text-sm text-passport",
                                                children: [
                                                    "I agree with Skipper's",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://skipper.io/terms",
                                                        target: "_blank",
                                                        className: "underline",
                                                        rel: "noreferrer",
                                                        children: "Terms of Service"
                                                    }),
                                                    " ",
                                                    "and",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://skipper.io/privacy",
                                                        target: "_blank",
                                                        className: "underline",
                                                        rel: "noreferrer",
                                                        children: "Privacy Policy"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "full text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                            variant: "secondary",
                                            size: "large",
                                            type: "submit",
                                            shape: "oval",
                                            className: "text-center mt-8 mx-auto w-[50%] mx-auto",
                                            onClick: handleSubmit(successCallback, errorCallback),
                                            disabled: createAccountMutation.isLoading || !checkboxState,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-center mx-auto",
                                                children: "".concat(createAccountMutation.isLoading ? "Signing up..." : "Sign up")
                                            })
                                        })
                                    })
                                ]
                            }))
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative z-20 w-full flex items-center justify-center mt-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: container,
                    className: "group relative flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-base text-gray-500",
                            children: "Already have an account?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/auth/signin",
                            rel: "noreferrer",
                            className: "block z-20 text-teal-600 font-bold",
                            children: "Log-in"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative z-20 w-full flex items-center justify-center mt-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: container,
                    className: "group relative flex items-center gap-x-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-base text-gray-500",
                            children: "Did not get email confirmation? "
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/auth/email/resend",
                            rel: "noreferrer",
                            className: "block z-20 text-teal-600 font-bold",
                            children: "Resend email"
                        })
                    ]
                })
            })
        ]
    });
};
var VerifyEmail = function(param) {
    var email = param.email, userId = param.userId, setShowSignUpForm = param.setShowSignUpForm, setEmail = param.setEmail, setUserId = param.setUserId;
    var dispatchNotification = (0,_components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_10__/* .useUniversalModalDispatch */ .Xt)().dispatchNotification;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "z-10",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex justify-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-10 lg:px-20 py-12 bg-white rounded-sm z-10 shadow-md border border-gray-100 lg:w-[50%] min-w-[400px] max-w-[700px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "lg:px-10 text-passport mb-4 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "md:text-4xl text-xl font-bold",
                            children: "Verify your email"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-sm leading-5 mt-8",
                            children: [
                                "We sent a verification link to",
                                " ",
                                !!email ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "font-bold",
                                    children: email
                                }) : "your email"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-sm leading-5 mt-6",
                            children: "Click on the link to complete the verification process. You may need to check your spam or junk folder."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "text-sm leading-5 mt-6",
                            children: [
                                "Need help? Contact support:",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-info font-bold cursor-pointer hover:text-teal-600",
                                    onClick: function() {
                                        var ref;
                                        navigator === null || navigator === void 0 ? void 0 : (ref = navigator.clipboard) === null || ref === void 0 ? void 0 : ref.writeText("hello@skipper.io");
                                        dispatchNotification({
                                            title: "Copied to clipboard",
                                            text: "",
                                            type: "success"
                                        });
                                    },
                                    children: "hello@skipper.io"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "leading-5 mt-1 text-danger cursor-pointer mt-2",
                            onClick: function() {
                                setShowSignUpForm(true);
                                setEmail("");
                                setUserId("");
                            },
                            children: "Back to sign-up"
                        })
                    ]
                })
            })
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(90359); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);